import { useEffect, useState } from "react";
import { Row, Col, Button, Spinner } from "react-bootstrap";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { IEditDate } from "./ChangeApplicabilityInterfaces";
import { dateFormat } from "../../common/Contants";
import "./ChangeApplicability.css";
import { EditDateAsync } from "../../api/simDocuments/PutDocumentService";
import SuccessPopUp from "../generic_components/SuccessPopUp";
dayjs.extend(customParseFormat);

export default function EditDate({ document, onErrorMessages }: IEditDate) {
  const [startDate, setStartDate] = useState(document.startDate || "");
  const [startDateError, setStartDateError] = useState<string | null>(null);
  const [endDateError, setEndDateError] = useState<string | null>(null);
  const [endDate, setEndDate] = useState(document.endDate || "");
  const validateDateFormat = (date: string) =>
    dayjs(date, dateFormat, true).isValid();
  const [valid, setValid] = useState(true);
  const parseDate = (date: string) => dayjs(date, dateFormat).toDate();
  const [load, setLoad] = useState(false);
  const [successPopUp, setSuccessPopUp] = useState(false);
  const [showError, setShowError] = useState(false);
  useEffect(() => {
    const isStartValid = validateDateFormat(startDate);
    const isEndValid = validateDateFormat(endDate);
    const start = isStartValid ? parseDate(startDate) : null;
    const end = isEndValid ? parseDate(endDate) : null;
    setValid(true);
    if (endDate !== "" && !isEndValid) {
      setEndDateError("Enter a valid End Date " + dateFormat);
      setValid(false);
    }

    if (!isStartValid) {
      setStartDateError("Enter a valid Start Date " + dateFormat);
      setValid(false);
    }

    if (end && start && start >= end) {
      setEndDateError("End Date should be Greater than Start Date");
      setValid(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    const putData = async () => {
      try {
        await EditDateAsync({
          documentReference: document.documentReference,
          startDate: dayjs(startDate, dateFormat).format("YYYY-MM-DD"),
          endDate:
            endDate != ""
              ? dayjs(endDate, dateFormat).format("YYYY-MM-DD")
              : null,
        });
        onErrorMessages([]);
        setSuccessPopUp(true);
      } catch (error: any) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;
          const messages = errors.map((err: any) => err.message);
          onErrorMessages(messages);
        } else {
          onErrorMessages([error.message]);
        }
      } finally {
        setLoad(false);
      }
    };

    if (load) {
      putData();
    }
  }, [load]);

  const handleUpdate = () => {
    setShowError(true);
    if (valid && startDate !== "") {
      setLoad(true);
    }
  };
  return (
    <>
      <Row className="padding-top">
        <Col xs={2}>
          <label>Start Date</label>
        </Col>
        <Col xs={3}>
          <input
            type="text"
            value={startDate}
            onChange={(e) => {
              onErrorMessages([]);
              setShowError(false);
              setStartDate(e.target.value);
              setStartDateError(null);
            }}
            placeholder={dateFormat}
            className="form-control"
          />
          {showError && startDateError && (
            <label className="errorMessage">{startDateError}</label>
          )}
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          <label>End Date</label>
        </Col>
        <Col xs={3}>
          <input
            type="text"
            value={endDate}
            onChange={(e) => {
              setShowError(false);
              onErrorMessages([]);
              setEndDate(e.target.value);
              setEndDateError(null);
            }}
            placeholder={dateFormat}
            className="form-control"
          />
          {showError && endDateError && (
            <label className="errorMessage">{endDateError}</label>
          )}
        </Col>
        <Col xs={3}>
          {load ? (
            <Spinner animation="border" />
          ) : (
            <Button
              className="btn btn-primary custom-button"
              onClick={handleUpdate}
            >
              Update start / end date
            </Button>
          )}
        </Col>
      </Row>
      <SuccessPopUp
        message="Document was successfully updated"
        showPopup={successPopUp}
      />
    </>
  );
}
